export const SUPPORTED_LANGS = ['es', 'en', 'fr', 'pt', 'ar'] as const;
export type Lang = typeof SUPPORTED_LANGS[number];

export const DEFAULT_LANG: Lang = 'es';
export const SITE_URL = 'https://scooterp.com';

export const RTL_LANGS: Lang[] = ['ar'];

export const LANG_NAMES: Record<Lang, string> = {
  es: 'Español',
  en: 'English',
  fr: 'Français',
  pt: 'Português',
  ar: 'العربية',
};

export const OG_LOCALES: Record<Lang, string> = {
  es: 'es_ES',
  en: 'en_US',
  fr: 'fr_FR',
  pt: 'pt_PT',
  ar: 'ar_SA',
};

// Route key -> translated slug per language
export const routeSlugs: Record<string, Record<Lang, string>> = {
  home:          { es: '',                  en: '',                  fr: '',                   pt: '',                  ar: '' },
  about:         { es: 'nosotros',          en: 'about',             fr: 'a-propos',           pt: 'sobre-nos',         ar: 'عنا' },
  contact:       { es: 'contacto',          en: 'contact',           fr: 'contact',            pt: 'contato',           ar: 'اتصل-بنا' },
  insurance:     { es: 'seguros',           en: 'insurance',         fr: 'assurances',         pt: 'seguros',           ar: 'تأمين' },
  repairStatus:  { es: 'estado-reparacion', en: 'repair-status',     fr: 'etat-reparation',    pt: 'estado-reparo',     ar: 'حالة-الإصلاح' },
  registration:  { es: 'matricula',         en: 'registration',      fr: 'immatriculation',    pt: 'matricula',         ar: 'تسجيل' },
  directory:     { es: 'talleres-de-patinetes-electricos', en: 'electric-scooter-workshops', fr: 'ateliers-trottinettes-electriques', pt: 'oficinas-de-trotinetes-eletricas', ar: 'ورش-عمل-سكوتر-كهربائي' },
  accessChoice:  { es: 'acceso',            en: 'access',            fr: 'acces',              pt: 'acesso',            ar: 'وصول' },
  blog:          { es: 'blog',              en: 'blog',              fr: 'blog',               pt: 'blog',              ar: 'مدونة' },
  legal:         { es: 'legal',             en: 'legal',             fr: 'mentions-legales',   pt: 'legal',             ar: 'قانوني' },
  localShop:     { es: 'tienda-taller',     en: 'shop',              fr: 'boutique',           pt: 'loja',              ar: 'متجر' },
  shop:          { es: 'tienda',            en: 'store',             fr: 'magasin',            pt: 'loja-online',       ar: 'متجر-إلكتروني' },
  shopCart:       { es: 'tienda/carrito',    en: 'store/cart',        fr: 'magasin/panier',     pt: 'loja-online/carrinho', ar: 'متجر-إلكتروني/سلة' },
  shopCheckout:   { es: 'tienda/checkout',  en: 'store/checkout',    fr: 'magasin/paiement',   pt: 'loja-online/checkout', ar: 'متجر-إلكتروني/دفع' },
  shopProduct:    { es: 'tienda/producto',  en: 'store/product',     fr: 'magasin/produit',    pt: 'loja-online/produto',  ar: 'متجر-إلكتروني/منتج' },
  shopWishlist:   { es: 'tienda/favoritos', en: 'store/wishlist',    fr: 'magasin/favoris',    pt: 'loja-online/favoritos', ar: 'متجر-إلكتروني/المفضلة' },
  shopCompare:    { es: 'tienda/comparar',  en: 'store/compare',     fr: 'magasin/comparer',   pt: 'loja-online/comparar',  ar: 'متجر-إلكتروني/مقارنة' },
  shopLogin:      { es: 'tienda/login',     en: 'store/login',       fr: 'magasin/connexion',  pt: 'loja-online/login',     ar: 'متجر-إلكتروني/تسجيل-دخول' },
  proTips:        { es: 'consejos-profesionales', en: 'professional-tips', fr: 'conseils-professionnels', pt: 'dicas-profissionais', ar: 'نصائح-مهنية' },
  faq:            { es: 'preguntas-frecuentes', en: 'faq', fr: 'foire-aux-questions', pt: 'perguntas-frequentes', ar: 'الأسئلة-الشائعة' },
  employeePortal: { es: 'fichar', en: 'clock-in', fr: 'pointage', pt: 'ponto', ar: 'تسجيل-حضور' },
  erpMain:        { es: 'soluciones/erp-tienda-taller-patinetes', en: 'solutions/erp-scooter-shop-workshop', fr: 'solutions/erp-boutique-atelier-trottinette', pt: 'solucoes/erp-loja-oficina-trotinete', ar: 'solutions/erp-متجر-ورشة-سكوتر' },
  moduleLanding:  { es: 'soluciones',          en: 'solutions',         fr: 'solutions',          pt: 'solucoes',          ar: 'solutions' },
  useCaseLanding: { es: 'soluciones',          en: 'solutions',         fr: 'solutions',          pt: 'solucoes',          ar: 'solutions' },
  sitemap:        { es: 'mapa-sitio',       en: 'sitemap',           fr: 'plan-du-site',      pt: 'mapa-do-site',      ar: 'خriطة-الموقع' },
  repairService:  { es: 'reparar-patinete-electrico', en: 'repair-electric-scooter', fr: 'reparer-trottinette-electrique', pt: 'reparar-trotinete-eletrica', ar: 'إصلاح-سكوتر-كهربائي' },
  scooterWorkshop: { es: 'taller-de-patinetes',     en: 'scooter-workshop',  fr: 'atelier-trottinettes', pt: 'oficina-de-trotinetes', ar: 'ورشة-سكوتر' },
  punctureRepair: { es: 'reparacion-pinchazos-patinete', en: 'scooter-puncture-repair', fr: 'reparation-crevaison-trottinette', pt: 'reparo-de-furo-trotinete', ar: 'إصلاح-ثقب-سكوتر' },
  nearMe:         { es: 'taller-patinete-electrico-cerca-de-mi', en: 'electric-scooter-workshop-near-me', fr: 'atelier-trottinette-electrique-proche-de-moi', pt: 'oficina-trotinete-eletrica-perto-de-mim', ar: 'ورشة-سكوتر-كهربائي-بالقرب-مني' },
  saasLanding:     { es: 'soluciones/erp-tienda-taller-patinetes-electricos', en: 'solutions/scooter-shop-workshop-erp', fr: 'solutions/erp-boutique-atelier-trottinette-electrique', pt: 'solucoes/erp-loja-oficina-trotinete-eletrica', ar: 'solutions/erp-متجر-ورشة-سكوتر' },
};

/**
 * Get the full path for a route in a specific language
 */
export function getLocalizedPath(routeKey: string, lang: Lang, params?: string): string {
  const slug = routeSlugs[routeKey]?.[lang] ?? routeSlugs[routeKey]?.es ?? '';
  const prefix = lang === DEFAULT_LANG ? '' : `/${lang}`;
  const path = slug ? `${prefix}/${slug}` : `${prefix}/`;
  return params ? `${path}/${params}` : path || '/';
}

/**
 * Get the absolute URL for a route in a specific language
 */
export function getLocalizedUrl(routeKey: string, lang: Lang, params?: string): string {
  return SITE_URL + getLocalizedPath(routeKey, lang, params);
}

/**
 * Find the route key from a slug in any language
 */
export function findRouteKey(slug: string): string | null {
  for (const [key, slugs] of Object.entries(routeSlugs)) {
    for (const lang of SUPPORTED_LANGS) {
      if (slugs[lang] === slug) return key;
    }
  }
  return null;
}

/**
 * Detect language from URL path
 */
export function detectLangFromPath(pathname: string): Lang {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length > 0 && SUPPORTED_LANGS.includes(segments[0] as Lang) && segments[0] !== 'es') {
    return segments[0] as Lang;
  }
  return DEFAULT_LANG;
}
